import React from 'react'
import { TrendIndicator } from 'src/components/analytics/common/TrendIndicator'

export interface BreakdownItem {
  label: string
  value: number | string
  change: number
  bold?: boolean
  reverseComparison?: boolean
}

interface BreakdownTableProps {
  data: BreakdownItem[]
  className?: string
}

const BreakdownTable: React.FC<BreakdownTableProps> = ({ data, className = '' }) => {
  return (
    <div className={`flex flex-col gap-4 ${className} h-full`}>
      {data.map(item => (
        <div
          key={item.label}
          className={`flex items-center justify-between bg-gray-lightest rounded-md px-6 py-4 flex-1 ${
            item.bold ? 'font-bold' : ''
          }`}
        >
          <span className={`text-sm ${item.bold ? 'font-bold' : 'font-normal'}`}>{item.label}</span>
          <div className='flex items-center gap-4'>
            <span className={`text-lg ${item.bold ? 'font-bold' : 'font-medium'}`}>{item.value}</span>
            <TrendIndicator
              value={item.change}
              formatter={value => `${Math.abs(value)}%`}
              reverse={item.reverseComparison}
            />
          </div>
        </div>
      ))}
    </div>
  )
}

export default BreakdownTable
